import { core } from '@tock/coretypes';
import { oc } from 'ts-optchain';

import AppConstants from 'constants/AppConstants';

export interface DeliveryAddress {
  address: core.ILocation;
  deliveryNotes: string;
  isServiceable?: boolean;
  phone: string;
  phoneCountryCode: string;
}

interface State {
  deliveryAddress?: DeliveryAddress;
  latestAutocomplete?: google.maps.places.AutocompletePrediction;
}

const initialState: State = {
  deliveryAddress: undefined,
};

export default function reducer(state: State = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.UPDATE_DELIVERY_ADDRESS: {
      const { deliveryAddress, latestAutocomplete } = payload;
      return {
        ...state,
        deliveryAddress,
        latestAutocomplete,
      };
    }
    case AppConstants.CALCULATE_PRICE_DONE: {
      if (state.deliveryAddress) {
        const isServiceable: boolean = oc(payload).delivery.isServiceable();
        return {
          ...state,
          deliveryAddress: {
            ...state.deliveryAddress,
            isServiceable,
          },
        };
      }
      return state;
    }
    default:
      return state;
  }
}
